import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FullScreenLoader } from '../components/ui/LoadingSpinner';
interface ProtectedRouteProps {
    children: React.ReactNode;
    adminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    adminOnly = false
}) => {
    const { user, isLoading } = useAuth();
    const [isAdmin, setIsAdmin] = React.useState(false);

    React.useEffect(() => {
        const checkAdminStatus = async () => {
            if (user && adminOnly) {
                try {
                    const token = await user.getIdTokenResult();
                    setIsAdmin(token.claims.admin === true);
                } catch (error) {
                    console.error('Error checking admin status:', error);
                }
            }
        };

        checkAdminStatus();
    }, [user, adminOnly]);

    if (isLoading) {
        return <FullScreenLoader message='Checking user status...' />;
    }

    if (!user) {
        return <Navigate to="/app/auth" replace />;
    }

    if (adminOnly && !isAdmin) {
        return <Navigate to="/app" replace />;
    }

    return <>{children}</>;
};